/**
 * Trigger a browser download for a Blob returned by an API call (e.g. a
 * backend-generated XLSX report). Mirrors the object-URL + temporary anchor
 * pattern used by the roster CSV export, but takes a ready-made Blob rather
 * than building one client-side.
 * @param {Blob} blob
 * @param {string} fileName
 */
export function downloadBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
